import { Flex } from "@chakra-ui/react";
import { ComicLabelsList } from "./ComicLabelsList";
import { ComicLabelsProps } from "./types";

export function ComicLabelsWrap({ comicData, labels }: ComicLabelsProps) {
  return (
    <Flex gap="4px" width="100%" flexDirection="row" flexWrap="wrap">
      <ComicLabelsList comicData={comicData} labels={labels} />
    </Flex>
  );
}
